import { render, staticRenderFns } from "./TaskUploadModal.vue?vue&type=template&id=b0c0a378&scoped=true"
import script from "./TaskUploadModal.vue?vue&type=script&lang=js"
export * from "./TaskUploadModal.vue?vue&type=script&lang=js"
import style0 from "./TaskUploadModal.vue?vue&type=style&index=0&id=b0c0a378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c0a378",
  null
  
)

export default component.exports